import { useEffect, useState } from "react";
import { DateTime } from "luxon";

export function defaultVideoTimezone() {
  return "America/Los_Angeles";
}
export function formatVideoRelease(instant, zone = "America/Los_Angeles") {
  return `${DateTime.fromISO(instant).setZone(zone).toLocaleString(DateTime.DATETIME_FULL)} (${zone})`;
}
export function scheduleError(instant) {
  if (instant === null || instant === undefined) return "";
  if (!instant || !Number.isFinite(Date.parse(instant))) return "Choose a valid release date and time.";
  if (Date.parse(instant) <= Date.now() + 60000) return "Schedule the release at least one minute in the future. Allow enough time for the upload to finish.";
  return "";
}
export default function VideoSchedule({ publishAt, timeZone, onChange, disabled }) {
  const [localTime, setLocalTime] = useState("");
  const enabled = publishAt !== null;
  useEffect(() => {
    if (publishAt === null) setLocalTime("");
    else if (publishAt) setLocalTime(DateTime.fromISO(publishAt).setZone(timeZone).toFormat("yyyy-MM-dd'T'HH:mm"));
  }, [publishAt, timeZone]);
  const parsed = DateTime.fromISO(localTime, { zone: timeZone });
  const valid = parsed.isValid && parsed.toFormat("yyyy-MM-dd'T'HH:mm") === localTime;
  const offsets = valid ? parsed.getPossibleOffsets().sort((a, b) => a.toMillis() - b.toMillis()) : [];
  const zones = [...new Set([timeZone, "UTC", ...(Intl.supportedValuesOf ? Intl.supportedValuesOf("timeZone") : ["America/Los_Angeles", "America/Denver", "America/Chicago", "America/New_York", "Europe/London"])])].sort();
  function changeLocal(value, zone = timeZone) {
    setLocalTime(value);
    const date = DateTime.fromISO(value, { zone });
    const matches = date.isValid && date.toFormat("yyyy-MM-dd'T'HH:mm") === value;
    const first = matches ? date.getPossibleOffsets().sort((a, b) => a.toMillis() - b.toMillis())[0] : null;
    onChange(first ? first.toUTC().toISO() : "", zone);
  }
  if (!enabled) return null;
  return <fieldset className="mediaUploadOptions" disabled={disabled}>
    <legend>Scheduled public release</legend>
      <div className="mediaFieldGrid"><label>Release date and time<input type="datetime-local" step="60" value={localTime} onChange={event => changeLocal(event.target.value)} /></label>
        <label>Release timezone<select value={timeZone} onChange={event => changeLocal(localTime, event.target.value)}>{zones.map(zone => <option key={zone} value={zone}>{zone}</option>)}</select></label></div>
      {localTime && !valid && <p role="alert" className="mediaError">Choose a valid local time. Some times do not exist when clocks change for daylight saving.</p>}
      {offsets.length > 1 && <label>Clock change occurrence<select value={Math.max(0, offsets.findIndex(date => date.toMillis() === Date.parse(publishAt)))} onChange={event => onChange(offsets[Number(event.target.value)].toUTC().toISO(), timeZone)}>{offsets.map((date, index) => <option key={date.toMillis()} value={index}>{index === 0 ? "First" : "Second"} occurrence ({date.offsetNameShort}, UTC{date.toFormat("ZZ")})</option>)}</select></label>}
      {publishAt && !scheduleError(publishAt) && <p className="mediaHint">Public release: {formatVideoRelease(publishAt, timeZone)}</p>}
      {publishAt && scheduleError(publishAt) && <p role="alert" className="mediaError">{scheduleError(publishAt)}</p>}
      <p className="mediaHint">Uploads now as private. YouTube makes it public at the selected time, even when this website is offline. Choose a time at least one minute ahead and allow time for uploading and processing.</p>
  </fieldset>;
}
